<div class="action-card">
  <img class="action-icon animate__animated animate__zoomIn" [src]="action.icon" alt="Icon" />
  <p class="action-text" [innerHTML]="action.description | translate"></p>
  <button mat-button (click)="action.action()">{{ action.buttonLabel | translate }}</button>
</div>
